export const longDateFormat = (str: string) => {
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(new Date(str))
}

export const shortDateFormat = (str: string) => {
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  }).format(new Date(str))
}

export const relativeDateFormat = (dateInput: string | number): string => {
  const date = new Date(dateInput)
  const now = new Date()

  // Calculate differences
  const diffInMilliseconds = now.getTime() - date.getTime()
  const diffInHours = diffInMilliseconds / (1000 * 60 * 60)
  const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24)

  // Check if within last 2 hours first (highest priority)
  if (diffInHours <= 2) {
    return 'Just now'
  }

  // Reset time to midnight for date comparisons
  const dateAtMidnight = new Date(date)
  dateAtMidnight.setHours(0, 0, 0, 0)

  const nowAtMidnight = new Date(now)
  nowAtMidnight.setHours(0, 0, 0, 0)

  const yesterdayAtMidnight = new Date(nowAtMidnight)
  yesterdayAtMidnight.setDate(yesterdayAtMidnight.getDate() - 1)

  // Check if date is today
  if (dateAtMidnight.getTime() === nowAtMidnight.getTime()) {
    return 'Today'
  }

  // Check if yesterday
  if (dateAtMidnight.getTime() === yesterdayAtMidnight.getTime()) {
    return 'Yesterday'
  }

  // Check if within last 7 days
  if (diffInDays <= 7) {
    return 'This week'
  }

  // Otherwise format as "30 June, 2025" with comma
  const formatted = new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date)

  // Add comma after month (e.g., "30 June 2025" -> "30 June, 2025")
  const parts = formatted.split(' ')
  if (parts.length === 3) {
    return `${parts[0]} ${parts[1]}, ${parts[2]}`
  }
  return formatted
}
